import React from 'react';
import PropTypes from 'prop-types';
//ICONS
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

/**
 * Muestra iconos dependiendo del estado de la propiedad `swap`.
 *
 * Cualquier otra propiedad no especificada en la documentacion sera reenviada al componente [Icon](https://material-ui.com/api/icon/).
 */
function IconSwap({swap, IconSwap, Icon, ...other}) {
   if (swap) {
      return <IconSwap data-testid="icon-swap" {...other} />;
   }
   return <Icon {...other} />;
}

IconSwap.propTypes = {
   /**
    * Si es __true__ el icon a mostrar sera el proporcionado por la propiedad `IconSwap`, caso contrario se mostrara el icono proporcionado por la propiedad `Icon`.
    */
   swap: PropTypes.bool,
   /**
    * Icono a mostrar cuando `swap` es __false__, default: @mui/icons-material/ExpandMore
    */
   Icon: PropTypes.elementType,
   /**
    * Icono a mostrar cuando `swap` es __true__, default: @mui/icons-material/ExpandLess
    */
   IconSwap: PropTypes.elementType
};
IconSwap.defaultProps = {
   swap: false,
   Icon: ExpandMore,
   IconSwap: ExpandLess
};
export default IconSwap;
